<template>
  <div class="report-class-content">
    <b-toast
      id="toast-check-modal-report-class-teacher"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-check.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-equis-modal-report-class-teacher"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-breadcrumb v-if="headerData">
      <b-breadcrumb-item
        :to="$route.params.flagReport ? '/teacher/student' : '/teacher/class'"
        >Classes</b-breadcrumb-item
      >
      <b-breadcrumb-item>
        <a @click="returnClass()">
          {{ $t("class-student.sub-titulo-tab-report") }}s:
          <template>
            {{ headerData.group }}
          </template>
        </a>
      </b-breadcrumb-item>
      <b-breadcrumb-item active
        >{{ $t("class-student.sub-titulo-tab-report") }}:
        <template>
          {{ headerData != null ? headerData.date : "" }}
        </template>
      </b-breadcrumb-item>
    </b-breadcrumb>
    <div class="card" v-if="headerData != null">
      <div class="card-body py-4">
        <a class="back-step mb-0" @click="returnClass()">
          <icon name="arrow-left" />{{ $t("planesYPrecios.regresar") }}
        </a>
        <h6 class="sub-title">
          <span>{{
            headerData
              ? (headerData.flagGroup ? "Group " : "") + headerData.group
              : ""
          }}</span>
        </h6>
        <b-row>
          <b-col md="6">
            <b-form-group label-cols-sm="4" content-cols-sm="8" label="Status:">
              <CustomSelect
                @input="idValueSelectselectedStatus"
                :options="optionsStatus"
                value="id"
                label="name"
                :default="' '"
                :valueSelected="headerData.id == 0 ? null : nameStateClass"
                :disabled="flagRegister"
              />
              <span class="error-input d-block">{{
                validationMsg($v.headerData.stateClassId)
              }}</span>
            </b-form-group>
            <b-form-group label-cols-sm="4" content-cols-sm="8" label="Date:">
              <b-input-group class="datepicker-group">
                <b-form-input
                  v-model="headerData.date"
                  :disabled="flagRegister"
                ></b-form-input>
                <b-input-group-append>
                  <b-form-datepicker
                    button-only
                    right
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="en"
                    @input="SetDateFormat"
                    :disabled="flagRegister"
                  ></b-form-datepicker>
                </b-input-group-append>
              </b-input-group>
              <span class="error-input d-block">{{
                validationMsg($v.headerData.date)
              }}</span>
              <!-- <div
                v-if="
                  (headerData.date == null || headerData.date == '') && flagSave
                "
                class="error-label my-2"
              >
                {{ $t("report-class.validation.date") }}
              </div> -->
            </b-form-group>
            <b-form-group v-if="headerData.flagGroup">
              <b-form-row>
                <legend class="col-sm-3 bv-no-focus-ring col-form-label">
                  Time:
                </legend>
                <b-col
                  sm="9"
                  class="d-flex align-items-center"
                  style="gap: 1rem"
                >
                  <b-form-timepicker
                    v-model="classStartTimeStr"
                    size="sm"
                    locale="en"
                    minutes-step="30"
                    :disabled="flagRegister"
                    @input="validateTime"
                  ></b-form-timepicker>
                  <label>-</label>
                  <b-form-timepicker
                    v-model="classEndTimeStr"
                    size="sm"
                    locale="en"
                    minutes-step="30"
                    :disabled="flagRegister"
                  ></b-form-timepicker>
                  <small v-if="isOvernight" class="text-muted">+1 day</small>
                </b-col>
              </b-form-row>
              <!--  <span class="error-input d-block">{{
                validationMsg($v.classStartTimeStr)
              }}</span> -->
              <div v-if="validateTime()" class="error-label text-center my-2">
                {{ $t("report-class.validation.startTime") }}
              </div>
            </b-form-group>
          </b-col>
          <b-col md="6" class="pl-lg-5">
            <template v-if="!headerData.flagGroup">
              <b-form-group
                label-cols-sm="3"
                content-cols-sm="9"
                label="Attendance:"
              >
                <div class="d-flex mt-1">
                  <b-form-radio
                    class="present m-auto"
                    v-model="items[0].assistance"
                    :disabled="
                      $route.params.flagTeacherReport == false ||
                      teacher.assistance ||
                      !editAssistance
                    "
                    :name="items[0].id"
                    :value="true"
                    >Present</b-form-radio
                  >
                  <b-form-radio
                    class="absent ml-5"
                    v-model="items[0].assistance"
                    :disabled="
                      $route.params.flagTeacherReport == false ||
                      teacher.assistance ||
                      !editAssistance
                    "
                    :name="items[0].id"
                    :value="false"
                    >Absent</b-form-radio
                  >
                </div>
                <span
                  v-if="
                    teacher.assistance == true
                      ? false
                      : items.some((x) => x.assistance == null) && flagSave
                  "
                  class="error-label my-2"
                >
                  {{ $t("reusables.obligatoryField") }}
                </span>
              </b-form-group>
              <b-form-group>
                <b-form-row>
                  <legend class="col-sm-3 bv-no-focus-ring col-form-label">
                    Time:
                  </legend>
                  <b-col
                    sm="9"
                    class="d-flex align-items-center"
                    style="gap: 1rem"
                  >
                    <b-form-timepicker
                      v-model="classStartTimeStr"
                      size="sm"
                      locale="en"
                      minutes-step="30"
                      :disabled="flagRegister"
                      @input="validateTime"
                    ></b-form-timepicker>
                    <label>-</label>
                    <b-form-timepicker
                      v-model="classEndTimeStr"
                      size="sm"
                      locale="en"
                      minutes-step="30"
                      :disabled="flagRegister"
                    ></b-form-timepicker>
                  </b-col>
                </b-form-row>
                <!-- <span class="error-input d-block">{{
                  validationMsg($v.classStartTimeStr)
                }}</span> -->
                <div v-if="validateTime()" class="error-label text-center my-2">
                  {{ $t("report-class.validation.startTime") }}
                </div>
              </b-form-group>
            </template>
            <div
              v-else
              class="table-assistance"
              :style="{
                pointerEvents:
                  parseInt(this.$route.params.classId) == 0
                    ? ''
                    : flagEdit
                    ? ''
                    : 'none',
                opacity:
                  parseInt(this.$route.params.classId) == 0
                    ? ''
                    : flagEdit
                    ? ''
                    : '0.8',
              }"
            >
              <div class="container-assistance">
                <b-table
                  sticky-header
                  :items="items"
                  :fields="fields"
                  responsive="sm"
                  class="w-100 mb-0"
                  :show-empty="true"
                  :empty-text="$t('reusables.empty-text')"
                >
                  <template #cell(assistance)="data">
                    <b-form-group class="container-radio mb-0">
                      <b-form-radio
                        class="present m-auto"
                        v-model="data.item.assistance"
                        :disabled="
                          $route.params.flagTeacherReport == false ||
                          teacher.assistance ||
                          !editAssistance
                        "
                        :name="data.item.id"
                        :value="true"
                      />
                      <!-- <b-form-radio class="absent" v-model="data.item.assistance" :name="data.item.id" :value="false" /> -->
                    </b-form-group>
                  </template>
                  <template #cell(absent)="data">
                    <b-form-group class="container-radio mb-0">
                      <b-form-radio
                        class="absent"
                        v-model="data.item.assistance"
                        :disabled="
                          $route.params.flagTeacherReport == false ||
                          teacher.assistance ||
                          !editAssistance
                        "
                        :name="data.item.id"
                        :value="false"
                      />
                    </b-form-group>
                  </template>
                </b-table>
                <div
                  v-if="
                    teacher.assistance == true
                      ? false
                      : items.some((x) => x.assistance == null) && flagSave
                  "
                  class="error-label text-center my-2"
                >
                  {{ $t("reusables.obligatoryField") }}
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="card mt-3" v-if="dataReport != null">
      <div class="card-body">
        <div :style="{ 'margin-top': '0px' }">
          <b-row>
            <b-col md="6">
              <b-form-group
                label-cols-sm="4"
                content-cols-sm="8"
                label="Teacher:"
              >
                <legend class="col-form-label">{{ personsTeacherName }}</legend>
              </b-form-group>
            </b-col>
            <b-col md="6" class="pl-lg-5">
              <b-form-group
                label-cols-sm="3"
                content-cols-sm="9"
                label="Course:"
              >
                <CustomSelect
                  v-if="dataResult"
                  @input="idValueSelectedCourses($event)"
                  :options="options"
                  value="valor"
                  label="descripcion_EN"
                  :valueSelected="
                    dataReport.id == 0 ? null : dataReport.nameSelectedCourses
                  "
                  :toggleTextDefault="toggleActiveDefaultText"
                  :disabled="disabledForm"
                  :default="' '"
                />
                <span class="error-input d-block">{{
                  validationMsg($v.dataReport.selectedCourses)
                }}</span>
                <!-- <div
                  v-if="
                    (dataReport.selectedCourses == null ||
                      dataReport.selectedCourses == '') &&
                    flagSave
                  "
                  class="error-label my-2"
                >
                  {{ $t("report-class.validation.course") }}
                </div> -->
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label-cols-sm="2"
                content-cols-sm="10"
                label="Topics:"
              >
                <!-- <b-col> -->
                <b-list-group
                  style="margin-left: -3px"
                  :class="disabledForm ? 'disabled' : ''"
                >
                  <b-list-group-item>
                    <b-form-input
                      v-model.trim="dataReport.eTopic.description"
                      :disabled="disabledForm"
                    ></b-form-input>
                  </b-list-group-item>
                </b-list-group>
                <span class="error-input d-block">{{
                  validationMsg($v.dataReport.eTopic.description)
                }}</span>
                <!-- <div
                  v-if="
                    (dataReport.eTopic.description == null ||
                      dataReport.eTopic.description == '') &&
                    flagSave
                  "
                  class="error-label my-2"
                >
                  {{ $t("report-class.validation.topics") }}
                </div> -->
                <!-- </b-col> -->
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-cols-sm="4"
                content-cols-sm="8"
                label="Materials:"
              >
                <b-form-input
                  class="mb-2"
                  v-for="(item, index) in dataReport.arrayMaterial"
                  :key="`item-${index}`"
                  v-model.trim="item.name"
                  :disabled="disabledForm"
                ></b-form-input>
                <div
                  v-if="
                    !$v.dataReport.arrayMaterial.$model.some((x) => x.name) &&
                    flagMaterialSave
                  "
                  class="error-label my-2"
                >
                  {{ $t("report-class.validation.Materials") }}
                </div>
                <span
                  v-if="!disabledForm"
                  style="font-size: 15px"
                  class="link blue d-inline-block"
                  :disabled="disabledForm"
                  @click="handleAddMaterial(dataReport.arrayMaterial)"
                  >Add material</span
                >
              </b-form-group>
            </b-col>
            <b-col md="6" class="pl-lg-5">
              <b-form-group
                label-cols-sm="3"
                content-cols-sm="9"
                label="Pages:"
              >
                <b-form-input
                  class="mb-2"
                  v-for="(item, index) in dataReport.arrayMaterial"
                  :key="`item-${index}`"
                  v-model.trim="item.description"
                  :disabled="disabledForm"
                ></b-form-input>
                <div
                  v-if="isMaterial && flagMaterialSave"
                  class="error-label my-2"
                >
                  {{ $t("report-class.validation.Pages") }}
                </div>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <b-form-row>
                  <legend class="col-form-label col-sm-2">Comments:</legend>
                  <b-col sm="10">
                    <b-form-textarea
                      v-model.trim="dataReport.commentary"
                      :disabled="disabledForm"
                      rows="4"
                      :class="{
                        'error-input': $v.dataReport.commentary.$error,
                      }"
                      no-resize
                      style="margin-left: -3px; width: calc(100% + 3px)"
                    >
                    </b-form-textarea>
                    <span class="error-input d-block">{{
                      validationMsg($v.dataReport.commentary)
                    }}</span>
                    <!-- <div
                      v-if="
                        (dataReport.commentary == null ||
                          dataReport.commentary == '') &&
                        flagSave
                      "
                      class="error-label my-2"
                    >
                      {{ $t("report-class.validation.comments") }}
                    </div> -->
                  </b-col>
                </b-form-row>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div
          v-if="$route.params.flagTeacherReport"
          class="text-center"
          style="display: flex; justify-content: center"
        >
          <div v-if="parseInt(this.$route.params.classId) != 0 && flagUpdate" style="display: flex; gap: 8px">
            <b-button
              v-if="parseInt(this.$route.params.classId) != 0 && !flagPaid ? true : false"
              variant="primary"
              class="save-report"
              :disabled="flagDeleting"
              @click="enableFormEdit"
            >
              {{ $t("reusables.edit") }}
            </b-button>
            <b-button
              v-if="parseInt(this.$route.params.classId) != 0 && !flagPaid && isCurrentMonth ? true : false"
              variant="danger"
              class="save-report ml-2"
              :disabled="flagDeleting"
              @click="handleDeleteReport"
            >
              <template v-if="!flagDeleting">{{ $t("reusables.delete") }}</template>
              <b-spinner
                v-else
                style="width: 1rem !important; height: 1rem !important; color: #ffffff;"
                label="Deleting"
              />
            </b-button>
          </div>
          <b-button
            v-else
            variant="primary"
            class="save-report ml-0"
            @click="handleSaveReport"
            :disabled="showSpinnerSave"
          >
            <template v-if="!showSpinnerSave">{{
              parseInt(this.$route.params.classId) != 0
                ? $t("reusables.save")
                : $t("reusables.save")
            }}</template>
            <b-spinner
              style="
                width: 1rem !important;
                height: 1rem !important;
                color: #ffffff;
              "
              v-else
              label="Spinning"
            >
            </b-spinner>
          </b-button>
        </div>

        <b-modal
          id="modalValidationCourse"
          :hide-footer="true"
          :hide-header="true"
        >
          <h6 class="sub-title">
            <span>{{ $t("report-class.modal.title") }}</span>
          </h6>
          <div class="d-block text-right">
            <button
              class="btn btn-primary mr-3"
              style="display: initial"
              @click="$bvModal.hide('modalValidationCourse')"
            >
              {{ $t("report-class.modal.button-1") }}
            </button>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
import CustomSelect from "@/components/form/select";
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import { required, requiredIf } from "vuelidate/lib/validators";
import { validationMessage } from "vuelidate-messages";
import {
  getNextClassDate,
  getNextClassTime,
  convertTimeToUTC,
  horarioObtenerNameClaseENConsolidado,
} from "@/assets/js/util.js";

const formMessages = {
  required: function () {
    return this.$t("reusables.obligatoryField");
  },
  isUnique: function () {
    return this.$t("reusables.courseAlreadySelected");
  },
  requiredIf: function () {
    return this.$t("reusables.obligatoryField");
  },
  validateDate: function () {
    return this.$t("report-class.validation.startTime");
  },
};

export default {
  data() {
    return {
      //flagMaterial: false,
      pagePrevId: "",
      toggleActiveDefaultText: false,
      initAssistance: false,
      editAssistance: false,
      value: false,
      optionsRadioButtons: [{ text: "", value: true }],
      showSpinnerSave: false,
      flagDeleting: false,
      message: "",
      headerData: null,
      flagUpdate: false,
      flagPaid: false,
      flagTeacherDisabled: false,
      flagEdit: false,
      optionsStatus: [],
      dataResult: false,
      dataReport: {
        id: 0,
        date: null,
        selectedCourses: null,
        nameSelectedCourses: null,
        commentary: null,
        eTopic: {
          description: null,
        },
        arrayMaterial: [
          {
            name: "",
            description: "",
          },
        ],
      },
      items: [],
      options: [],
      fieldsTeacher: [
        {
          key: "strFullName",
          label: this.$t("report-class.table-th.strFullName"),
          thClass: "text-left",
          tdClass: "text-left",
        },
        {
          key: "assistance",
          label: this.$t("report-class.table-th.assistance"),
        },
        { key: "absent", label: this.$t("report-class.table-th.absent") },
      ],
      fields: [
        {
          key: "student",
          label: this.$t("report-class.table-th.student"),
          thClass: "text-left",
          tdClass: "text-left",
        },
        {
          key: "assistance",
          label: this.$t("report-class.table-th.assistance"),
        },
        { key: "absent", label: this.$t("report-class.table-th.absent") },
      ],
      teacher: {},
      isEnable: true,
      flagSave: false,
      flagMaterialSave: false,
      countFlag: 0,
      //classDuration: 0,
      //classDurationStr: '',
      classStartTimeStr: "",
      classEndTimeStr: "",
      pStateCompletedClass: 0,
      pStateTeacherAbsent: 0,
      pStateStudentAsbsent: 0,
      pStateCanceledStudent: 0,
      flagRegister: false,
      personsTeacherName: "",
      nameStateClass: "",
      dateOriginal: null,
      endDateOriginal: null,
      classStartTimeStrOriginal: "",
      classEndTimeStrOriginal: "",
      addEndDate: false,
    };
  },
  components: {
    CustomSelect,
  },
  validations: {
    headerData: {
      date: { required },
      stateClassId: { required },
    },
    dataReport: {
      id: {
        required,
      },
      selectedCourses: {
        required,
      },
      nameSelectedCourses: {},
      commentary: {
        required,
      },
      eTopic: {
        description: {
          required,
        },
      },
      arrayMaterial: {
        required,
        $each: {
          name: {
            required: requiredIf(function (model) {
              let dataReport = this.dataReport;
              let flag = dataReport.arrayMaterial.some((x) => x.name);
              return !flag;
            }),
          },
          description: {
            required: requiredIf(function (model) {
              debugger;
              console.log(model);
              let dataReport = this.dataReport;
              let flag = dataReport.arrayMaterial.some((x) => x.description);
              return !flag;
            }),
          },
        },
      },
    },
    items: {
      $each: {
        assistance: {
          required,
        },
      },
    },
    teacher: {
      required,
      assistance: {
        required,
      },
    },
    validationGroup: ["dataReport", "items", "teacher", "headerData"],
  },
  computed: {
    isMaterial: function () {
      let conDatos = !this.dataReport.arrayMaterial.some((x) => x.description);
      if (conDatos) {
        return true;
      } else {
        console.log(this.dataReport.arrayMaterial);
        if (this.dataReport.arrayMaterial.length > 1) {
          var isNames = this.dataReport.arrayMaterial.filter(
            (x) => x.name != "" && x.description == ""
          ).length;
          return isNames > 0;
        } else return false;
      }
    },
    disabledForm: function () {
      let isEdit = this.$route.params.classId == 0 ? false : !this.flagEdit;
      let isStateTeacherAbsent =
        this.headerData != null
          ? this.headerData.stateClassId != undefined
            ? !(this.pStateCompletedClass == this.headerData.stateClassId)
            : false
          : false;
      if (isStateTeacherAbsent) {
        return true;
      } else {
        if (this.$route.params.flagTeacherReport) {
          if (this.teacher.assistance || isEdit) {
            return true;
          }
          let count = 0;

          this.items.forEach((element) => {
            if (!element.assistance && element.assistance != null) {
              count++;
            }
          });

          if (this.items.length == count) {
            if (this.value == false) {
              this.cleanText(true, false);
            }
            return true;
          }
          return false;
        } else {
          return true;
        }
      }
    },
    groupId: {
      get() {
        return this.$store.state.group_id;
      },
      set(value) {
        this.$store.commit("mutateGroupId", value);
      },
    },
    User: {
      get() {
        return this.$store.state.user;
      },
    },
    isCurrentMonth() {
      if (!this.headerData || !this.headerData.date) return false;
      const classDate = this.$moment(this.headerData.date, 'MM/DD/YYYY');
      const now = this.$moment();
      return classDate.month() === now.month() && classDate.year() === now.year();
    },
  },
  created() {
    if (this.$route.params.pagePrevId != undefined) {
      this.pagePrevId = this.$route.params.pagePrevId;
    }
    if (this.$route.params.flagReport != undefined) {
      if (
        this.$route.params.flagNoSchedule != undefined &&
        this.$route.params.flagNoSchedule
      ) {
        this.getDetailReportByGroupPlan();
      } else {
        this.getDetailReport();
      }
      this.flagUpdate = parseInt(this.$route.params.classId) != 0;
      if (this.flagUpdate) {
        this.flagPaid = this.$route.params.flagPaid;
        this.value = this.flagUpdate;
        this.getAssistence();
      }
    } else {
      this.$router
        .push({
          name: "teacher-class",
        })
        .catch((err) => {});
    }
  },
  watch: {
    dataReport: function (val) {
      if (val != undefined && val != null) {
        if (val.selectedCourses === null) {
          this.toggleActiveDefaultText = !this.toggleActiveDefaultText;
        }
      }
    },
  },
  methods: {
    returnClass: function () {
      let self = this;
      if (this.$route.params.flagReport) {
        self.$router.push({
          path: "/teacher/student",
        });
      } else {
        var _data = JSON.parse(atob(this.pagePrevId));
        self.$router.push({
          name: "teacher-class-list-report",
          params: {
            filterGroupId: _data.filterGroupId,
            filterNameStudent: _data.filterNameStudent,
            pIsGroup: _data.pIsGroup,
            pStudent: _data.pStudent,
            pCodeGroup: _data.pCodeGroup,
            pTotalHoursSchedule: _data.pTotalHoursSchedule,
            pDuration: _data.pDuration,
            pPercentageCompleted: _data.pPercentageCompleted,
            pFlagRegistroClass: false,
          },
        });
      }
    },
    validateTime: function () {
      if (!this.classStartTimeStr || !this.classEndTimeStr) return false;
      return this.classStartTimeStr === this.classEndTimeStr;
    },
    isOvernight: function () {
      if (!this.classStartTimeStr || !this.classEndTimeStr) return false;
      return this.classEndTimeStr < this.classStartTimeStr;
    },
    dateFormat: function (date) {
      var sDate = this.$moment(date);
      var combinedDateTime = this.$moment({
        year: sDate.year(),
        month: sDate.month(),
        day: sDate.date(),
      });
      return combinedDateTime.format();
    },
    dateTimeFormat: function (date, time) {
      var sDate = this.$moment(date);
      var selectedTime = this.$moment(time, "hh:mm a");
      var combinedDateTime = this.$moment({
        year: sDate.year(),
        month: sDate.month(),
        day: sDate.date(),
        hour: selectedTime.hour(),
        minute: selectedTime.minute(),
      });
      return combinedDateTime.format();
    },
    SetDateFormat: function (value) {
      let dateFormat = this.$moment(value, "YYYY-MM-DD").format("MM/DD/YYYY");
      this.headerData.date = dateFormat;
    },
    idValueSelectselectedStatus(event) {
      this.headerData.stateClassId = event;
      this.teacher.assistance =
        this.headerData.stateClassId == this.pStateTeacherAbsent ||
        this.headerData.stateClassId == this.pStateCanceledStudent;
      this.value = !(this.headerData.stateClassId == this.pStateCompletedClass);
      if (
        this.headerData.stateClassId == this.pStateTeacherAbsent ||
        this.headerData.stateClassId == this.pStateCanceledStudent
      ) {
        this.getAssistence();
      }
      if (this.headerData.stateClassId == this.pStateStudentAsbsent) {
        this.cleanText(true, false);
      }
    },
    idValueSelectedCourses(event) {
      this.dataReport.selectedCourses = event;
    },
    enableFormEdit() {
      this.flagUpdate = false;
      this.flagEdit = true;
      this.flagRegister = false;
      this.editAssistance = true;
    },
    handleDeleteReport() {
      const h = this.$createElement;
      const messageVNode = h("div", {
        domProps: {
          innerHTML:
            '<p class="text-center">Are you sure you want to delete this class report? This action cannot be undone.</p>',
        },
      });
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          size: "md",
          buttonSize: "sm",
          cancelVariant: "primary",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-3 justify-content-center",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirmed) => {
          if (!confirmed) return;
          this.flagDeleting = true;
          baseInstanceAxios
            .post(
              `${this.apiURL}/resources/GroupsPlanClass/GroupsPlanClassDelete`,
              {
                Id: parseInt(this.$route.params.classId),
                GroupPlanId: parseInt(this.$route.params.pGroupPlanId),
                User: this.User.email,
              }
            )
            .then((response) => {
              if (response.data && response.data.return) {
                this.message = this.$t("valid.report-successfully-deleted");
                this.$bvToast.show("toast-check-modal-report-class-teacher");
                setTimeout(() => this.returnClass(), 1500);
              } else {
                this.flagDeleting = false;
                this.message = response.data.message || this.$t("error.error-saving-report");
                this.$bvToast.show("toast-equis-modal-report-class-teacher");
              }
            })
            .catch(() => {
              this.flagDeleting = false;
              this.message = this.$t("error.error-saving-report");
              this.$bvToast.show("toast-equis-modal-report-class-teacher");
            });
        });
    },
    cleanText(flagInit, flagAttendanceStudents) {
      if (flagInit == true) {
        if (flagAttendanceStudents == true) {
          if (this.items.length > 0) {
            this.items.forEach((element) => {
              element.assistance = null;
            });
          }
        }
        this.dataReport = null;
        this.nameStateClass = "";
        this.dataReport = {
          id: 0,
          selectedCourses: null,
          nameSelectedCourses: null,
          commentary: null,
          eTopic: {
            description: null,
            idx: 0,
          },
          arrayMaterial: [
            {
              name: "",
              description: "",
              idx: 0,
            },
          ],
        };
      }
    },
    getAssistence() {
      this.teacher.assistance = this.value;
      if (this.value == true) {
        this.cleanText(true, true);
      }
    },
    getDisabledSelect(id) {
      var count = 0;
      if (this.teacher.assistance) {
        return true;
      }
      if (parseInt(this.$route.params.classId) != 0) {
        if (id != 0) {
          return true;
        } else {
          count = 0;
          this.items.forEach((element) => {
            if (!element.assistance && element.assistance != null) {
              count++;
            }
          });

          if (this.items.length == count) {
            return true;
          }

          return false;
        }
      } else {
        count = 0;
        this.items.forEach((element) => {
          if (!element.assistance && element.assistance != null) {
            count++;
          }
        });

        if (this.items.length == count) {
          return true;
        }

        return false;
      }
    },
    validationMsg: validationMessage(formMessages),
    handleAddMaterial(arrayMaterial) {
      arrayMaterial.push({
        name: "",
        description: "",
        idx: 0,
      });
    },
    test() {
      var classStartDateTzUTC = convertTimeToUTC(
        this.headerData.date + " " + this.classStartTimeStr,
        this.$store.state.user.timeZoneName,
        this.$moment
      );
      var classEndDateTzUTC = convertTimeToUTC(
        this.headerData.date + " " + this.classEndTimeStr,
        this.$store.state.user.timeZoneName,
        this.$moment
      );
      console.log("classStartDateTzUTC: " + classStartDateTzUTC);
    },
    handleSaveReport() {
      let flagValid = false;
      let flagheaderData = false;
      if (!this.teacher.assistance) {
        if (!this.disabledForm) {
          this.flagSave = true;
          if (this.headerData.stateClassId == this.pStateStudentAsbsent) {
            this.flagMaterialSave = false;
          } else {
            this.flagMaterialSave = true;
          }
          this.$v.$touch();
          if (!(this.teacher && this.teacher.assistance == false)) {
            flagValid = true;

            if (this.items && this.items.every((x) => x.assistance == false))
              flagValid = false;
          }
          if (this.$v.$invalid) {
            return;
          } else {
            if (!this.flagRegister) {
              var validatetime = this.validateTime();
              if (validatetime) {
                return;
              }
            }
          }
        } else {
          if (this.$v.headerData.$invalid) {
            flagheaderData = true;
          }
          this.flagSave = false;
        }
      } else {
        if (this.$v.headerData.$invalid) {
          flagheaderData = true;
        }
      }
      if (!this.flagRegister) {
        var fValidatetime = this.validateTime();
        if (fValidatetime) {
          return;
        }
      }
      if (flagheaderData) {
        this.$v.headerData.$touch();
        return;
      }
      //validar inasistencia de estudiante
      if (this.headerData.stateClassId == this.pStateStudentAsbsent) {
        let count = 0;
        this.items.forEach((element) => {
          if (!element.assistance && element.assistance != null) {
            count++;
          }
        });

        if (this.items.length != count) {
          this.message = this.$t("error.error-registering-studentAsbsent");

          this.$bvToast.show("toast-equis-modal-report-class-teacher");
          return;
        }
      } else if (this.headerData.stateClassId == this.pStateCompletedClass) {
        let count = 0;
        this.items.forEach((element) => {
          if (!element.assistance && element.assistance != null) {
            count++;
          }
        });

        if (this.items.length == count) {
          this.message = this.$t("error.error-registering-completedClass");

          this.$bvToast.show("toast-equis-modal-report-class-teacher");
          return;
        }
      }
      const h = this.$createElement;
      const messageVNode = h("div", {
        domProps: {
          innerHTML:
            '<p class="text-center">Do you want to save these changes?</p>',
        },
      });
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          size: "md",
          buttonSize: "sm",
          cancelVariant: "danger",
          okVariant: "primary",
          okTitle: "Save",
          cancelTitle: "Cancel",
          footerClass: "p-3 justify-content-center",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.showSpinnerSave = true;
            let arrayStudents = [];
            let eData = null;

            if (!this.teacher.assistance) {
              if (
                this.headerData.stateClassId == this.pStateCompletedClass ||
                this.headerData.stateClassId == this.pStateStudentAsbsent
              ) {
                this.items.forEach((element) => {
                  arrayStudents.push({
                    Id: element.idRegister,
                    GroupsPersonsId: element.groupsPersonsId,
                    FlagAttendance: element.assistance,
                  });
                });
              }

              if (!this.disabledForm) {
                eData = {
                  Id: this.dataReport.id,
                  GroupRegisterSubjectId: parseInt(
                    this.dataReport.selectedCourses,
                    10
                  ),
                  Comment: this.dataReport.commentary,
                  GetDtoGroupsPlanClassSubjectTopics: {
                    Description: this.dataReport.eTopic.description,
                  },
                  ListDtoGroupsPlanClassSubjectMaterials:
                    this.dataReport.arrayMaterial.filter((x) => x.name),
                };
              }
            }
            let json = {
              User: this.User.email,
              Id: parseInt(this.$route.params.classId),
              StateClassId: this.headerData.stateClassId,
              ScheduleTeacherDetailId: parseInt(this.$route.params.id),
              FlagAttendanceClass: !this.disabledForm,
              FlagAttendanceTeacher: !this.teacher.assistance,
              PersonTeacherId: this.User.personTeacherId,
              ListGroupsPlanClassAttendances: arrayStudents,
              GetGroupsPlanClassSubject: eData,
              ClassStartDateTz: convertTimeToUTC(
                this.headerData.date + " " + this.classStartTimeStr,
                this.$store.state.user.timeZoneName,
                this.$moment
              ),
              ClassEndDateTz: convertTimeToUTC(
                (this.isOvernight()
                  ? this.$moment(this.headerData.date).add(1, 'days').format('YYYY-MM-DD')
                  : this.headerData.date) + " " + this.classEndTimeStr,
                this.$store.state.user.timeZoneName,
                this.$moment
              ),
              GroupPlanId: parseInt(this.$route.params.pGroupPlanId),
            };
            var _url = "GroupsPlanClassSave";
            if (
              this.$route.params.flagNoSchedule != undefined &&
              this.$route.params.flagNoSchedule
            ) {
              _url = "GroupsPlanClassSaveByGroupPlan";
            }
            let self = this;
            baseInstanceAxios
              .post(`${this.apiURL}/resources/GroupsPlanClass/${_url}`, json)
              .then((response) => {
                if (response.data != null && response.data.value == -100) {
                  this.showSpinnerSave = false;
                  this.message = this.$t("valid.report-validate-duration");
                  this.$bvToast.show("toast-equis-modal-report-class-teacher");
                } else {
                  this.message = this.$t("valid.report-successfully-saved");
                  this.$bvToast.show("toast-check-modal-report-class-teacher");
                  this.showSpinnerSave = false;
                  this.flagUpdate = true;
                  this.flagEdit = false;
                  this.editAssistance = false;
                  this.flagRegister = true;
                  if (parseInt(this.$route.params.classId) === 0 && response.data.value > 0) {
                    this.$router.replace({
                      name: this.$route.name,
                      params: { ...this.$route.params, classId: response.data.value },
                    });
                  }
                }
              })
              .catch(() => {
                this.showSpinnerSave = false;
                this.message = this.$t("error.error-saving-report");

                this.$bvToast.show("toast-equis-modal-report-class-teacher");
              });
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    getDetailReport() {
      this.dataReport = null;
      this.items = [];
      this.options = [];
      this.flagTeacherDisabled = false;
      let params = {
        ScheduleTeachersDetailId: parseInt(this.$route.params.id),
        GroupPlanClassId: parseInt(this.$route.params.classId),
      };

      let format_day = "MM/DD/YYYY";
      let format_time = "h:mm a";

      baseInstanceAxios
        .get(`${this.apiURL}/resources/PersonsTeachers/GetReportClassTeacher`, {
          params,
        })
        .then((response) => {
          this.dataResult = true;
          this.pStateCompletedClass = response.data.entity.stateCompletedClass;
          this.pStateTeacherAbsent = response.data.entity.stateTeacherAbsent;
          this.pStateStudentAsbsent = response.data.entity.stateStudentAsbsent;
          this.pStateCanceledStudent =
            response.data.entity.stateCanceledStudent;

          response.data.entity.listStatus.forEach((element) => {
            element.name = horarioObtenerNameClaseENConsolidado(element.value);
          });
          this.optionsStatus = response.data.entity.listStatus;
          this.options = response.data.entity.listSubjects;
          this.nameStateClass = horarioObtenerNameClaseENConsolidado(
            response.data.entity.valueStateClass
          );
          this.editAssistance = this.$route.params.classId == 0 ? true : false;
          if (response.data.entity.scheduleTeachersDetails) {
            /* this.isEnable =
              parseInt(this.$route.params.classId) == 0
                ? true
                : response.data.entity.scheduleTeachersDetails.stateClassId ==
                  response.data.entity.stateCompletedClass; */
            this.personsTeacherName =
              response.data.entity.scheduleTeachersDetails.personsTeacher.person.strFullName;
            this.headerData = {
              id: response.data.entity.scheduleTeachersDetails.id,
              date: getNextClassDate(
                response.data.entity.scheduleTeachersDetails.startDate,
                this.$store.state.user.timeZoneName,
                this.$moment,
                format_day
              ),
              hours: getNextClassTime(
                response.data.entity.scheduleTeachersDetails.startDate,
                response.data.entity.scheduleTeachersDetails.endDate,
                this.$store.state.user.timeZoneName,
                this.$moment,
                format_time
              ),

              flagGroup: response.data.entity.scheduleTeachersDetails.flagGroup,
              group: response.data.entity.scheduleTeachersDetails.className,
              stateClassId:
                parseInt(this.$route.params.classId) == 0
                  ? null
                  : response.data.entity.scheduleTeachersDetails.stateClassId,
            };
            this.dateOriginal = this.headerData.date;
            this.endDateOriginal = getNextClassDate(
              response.data.entity.scheduleTeachersDetails.endDate,
              this.$store.state.user.timeZoneName,
              this.$moment,
              format_day
            );
            let teacher =
              response.data.entity.scheduleTeachersDetails.personsTeacher;

            this.teacher = {
              id: teacher.id + "",
              strFullName: teacher.person.strFullName,
              assistance: !teacher.flagAttendance,
            };

            if (parseInt(this.$route.params.classId) == 0) {
              this.teacher.assistance = false;
            } else {
              this.flagRegister = true;
            }
            this.value = this.teacher.assistance;
          }
          if (this.countFlag == 0) {
            this.initAssistance = this.teacher.assistance;
          }
          this.countFlag++;

          this.items = response.data.entity.listStudents.map((x) => ({
            id: x.personStudent.id + "",
            idRegister: x.id,
            groupsPersonsId: x.personStudent.groupPersonId,
            student: x.personStudent.person.strFullName,
            assistance: x.flagAttendance,
          }));

          let entityReport = null;
          let isRegister = false;
          if (response.data.entity.getGroupsPlanClassSubject != null) {
            let element = response.data.entity.getGroupsPlanClassSubject;
            let arrayMaterial =
              element.listDtoGroupsPlanClassSubjectMaterials.map((x) => ({
                name: x.name,
                description: x.description,
                idx: x.id,
              }));

            let eTopic =
              element.getDtoGroupsPlanClassSubjectTopics == null
                ? null
                : {
                    description:
                      element.getDtoGroupsPlanClassSubjectTopics.description,
                    idx: element.getDtoGroupsPlanClassSubjectTopics.id,
                  };
            entityReport = {
              id: element.id,
              selectedCourses: element.groupRegisterSubjectId,
              nameSelectedCourses: element.subjectsName,
              commentary: element.comment,
              eTopic: eTopic,
              arrayMaterial: arrayMaterial,
              subjectsPosition: element.subjectsPosition,
            };
          } else {
            isRegister = true;
            entityReport = {
              id: 0,
              selectedCourses: null,
              nameSelectedCourses: null,
              commentary: null,
              eTopic: {
                description: null,
              },
              arrayMaterial: [
                {
                  name: "",
                  description: "",
                  idx: 0,
                },
              ],
            };
          }

          this.dataReport = entityReport;
          /*  if (isRegister && this.options.length > 0)
            this.dataReport.selectedCourses = this.options[0].valor; */
          if (this.teacher != null) {
            this.flagTeacherDisabled = this.teacher.assistance;
          }
          this.classStartTimeStr = this.$moment(
            this.$moment(
              response.data.entity.scheduleTeachersDetails.startDate
            ).utc()
          )
            .tz(this.$store.state.user.timeZoneName)
            .format("HH:mm:ss");
          this.classEndTimeStr = this.$moment(
            this.$moment(
              response.data.entity.scheduleTeachersDetails.endDate
            ).utc()
          )
            .tz(this.$store.state.user.timeZoneName)
            .format("HH:mm:ss");

          this.classStartTimeStrOriginal = this.classStartTimeStr;
          this.classEndTimeStrOriginal = this.classEndTimeStr;
        });
    },
    getDetailReportByGroupPlan() {
      this.dataReport = null;
      this.items = [];
      this.options = [];
      this.flagTeacherDisabled = false;
      let params = {
        GroupPlanId: parseInt(this.$route.params.pGroupPlanId),
        GroupPlanClassId: parseInt(this.$route.params.classId),
      };

      let format_day = "MM/DD/YYYY";
      let format_time = "h:mm a";

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsTeachers/GetReportClassTeacherByGroupPlan`,
          {
            params,
          }
        )
        .then((response) => {
          this.dataResult = true;
          this.pStateCompletedClass = response.data.entity.stateCompletedClass;
          this.pStateTeacherAbsent = response.data.entity.stateTeacherAbsent;
          this.pStateStudentAsbsent = response.data.entity.stateStudentAsbsent;
          this.pStateCanceledStudent =
            response.data.entity.stateCanceledStudent;
          response.data.entity.listStatus.forEach((element) => {
            element.name = horarioObtenerNameClaseENConsolidado(element.value);
          });
          this.optionsStatus = response.data.entity.listStatus;
          this.options = response.data.entity.listSubjects;
          this.nameStateClass = horarioObtenerNameClaseENConsolidado(
            response.data.entity.valueStateClass
          );
          this.editAssistance = this.$route.params.classId == 0 ? true : false;
          if (response.data.entity.scheduleTeachersDetails) {
            /*       this.isEnable =
              parseInt(this.$route.params.classId) == 0
                ? true
                : response.data.entity.scheduleTeachersDetails.stateClassId ==
                  response.data.entity.stateCompletedClass; */
            this.personsTeacherName =
              response.data.entity.scheduleTeachersDetails.personsTeacher.person.strFullName;
            this.headerData = {
              id: response.data.entity.scheduleTeachersDetails.id,
              date: getNextClassDate(
                response.data.entity.scheduleTeachersDetails.startDate,
                this.$store.state.user.timeZoneName,
                this.$moment,
                format_day
              ),
              hours: getNextClassTime(
                response.data.entity.scheduleTeachersDetails.startDate,
                response.data.entity.scheduleTeachersDetails.endDate,
                this.$store.state.user.timeZoneName,
                this.$moment,
                format_time
              ),

              flagGroup: response.data.entity.scheduleTeachersDetails.flagGroup,
              group: response.data.entity.scheduleTeachersDetails.className,
              stateClassId:
                parseInt(this.$route.params.classId) == 0
                  ? null
                  : response.data.entity.scheduleTeachersDetails.stateClassId,
            };
            this.dateOriginal = this.headerData.date;
            this.endDateOriginal = getNextClassDate(
              response.data.entity.scheduleTeachersDetails.endDate,
              this.$store.state.user.timeZoneName,
              this.$moment,
              format_day
            );
            let teacher =
              response.data.entity.scheduleTeachersDetails.personsTeacher;

            this.teacher = {
              id: teacher.id + "",
              strFullName: teacher.person.strFullName,
              assistance: !teacher.flagAttendance,
            };

            if (parseInt(this.$route.params.classId) == 0) {
              this.teacher.assistance = false;
            } else {
              this.flagRegister = true;
            }
            this.value = this.teacher.assistance;
          }
          if (this.countFlag == 0) {
            this.initAssistance = this.teacher.assistance;
          }
          this.countFlag++;

          this.items = response.data.entity.listStudents.map((x) => ({
            id: x.personStudent.id + "",
            idRegister: x.id,
            groupsPersonsId: x.personStudent.groupPersonId,
            student: x.personStudent.person.strFullName,
            assistance: x.flagAttendance,
          }));
          let entityReport = null;
          let isRegister = false;
          if (response.data.entity.getGroupsPlanClassSubject != null) {
            let element = response.data.entity.getGroupsPlanClassSubject;
            let arrayMaterial =
              element.listDtoGroupsPlanClassSubjectMaterials.map((x) => ({
                name: x.name,
                description: x.description,
                idx: x.id,
              }));

            let eTopic =
              element.getDtoGroupsPlanClassSubjectTopics == null
                ? null
                : {
                    description:
                      element.getDtoGroupsPlanClassSubjectTopics.description,
                    idx: element.getDtoGroupsPlanClassSubjectTopics.id,
                  };
            entityReport = {
              id: element.id,
              selectedCourses: element.groupRegisterSubjectId,
              nameSelectedCourses: element.subjectsName,
              commentary: element.comment,
              eTopic: eTopic,
              arrayMaterial: arrayMaterial,
              subjectsPosition: element.subjectsPosition,
            };
          } else {
            isRegister = true;
            entityReport = {
              id: 0,
              selectedCourses: null,
              nameSelectedCourses: null,
              commentary: null,
              eTopic: {
                description: null,
              },
              arrayMaterial: [
                {
                  name: "",
                  description: "",
                  idx: 0,
                },
              ],
            };
          }
          this.dataReport = entityReport;
          /*    if (isRegister && this.options.length > 0)
            this.dataReport.selectedCourses = this.options[0].valor; */

          if (this.teacher != null) {
            this.flagTeacherDisabled = this.teacher.assistance;
          }
          this.classStartTimeStr = this.$moment(
            this.$moment(
              response.data.entity.scheduleTeachersDetails.startDate
            ).utc()
          )
            .tz(this.$store.state.user.timeZoneName)
            .format("HH:mm:ss");
          this.classEndTimeStr = this.$moment(
            this.$moment(
              response.data.entity.scheduleTeachersDetails.endDate
            ).utc()
          )
            .tz(this.$store.state.user.timeZoneName)
            .format("HH:mm:ss");

          this.classStartTimeStrOriginal = this.classStartTimeStr;
          this.classEndTimeStrOriginal = this.classEndTimeStr;
        });
    },
    /*changeTimeHandler(eventData){
       
      this.classDuration = (parseInt(eventData.data.h, 10) * 60 ) + (parseInt(eventData.data.m, 10))
    }*/
  },
};
</script>

<style>
.vue__time-picker input.display-time {
  border-radius: 8px;
  color: #2b305d;
  border: 1px solid #b7b8bd;
  padding: 5px 15px;
}
.vue__time-picker input.display-time:disabled,
.vue__time-picker input.display-time.disabled {
  opacity: 1;
  color: #2b305d;
  background-color: #e9ecef;
}
</style>